import React, { useContext } from "react";
import cardStyle from "../reserve.module.css";
import { MdCircle } from "react-icons/md";
import { ApplicationContext } from "../../../context/ApplicationContextProvider";
import { useNavigate } from "react-router-dom";
const ReserveCard = ({ reserveData }) => {
  const { setPartnerBookData } = useContext(ApplicationContext);
  const navigate = useNavigate();
  const handleRedirectCard = (data) => {
    setPartnerBookData(data);
    navigate("/du-daily-partner-status");
  };
  return (
    <div
      className={cardStyle.reserveCardContainer}
      onClick={() => handleRedirectCard(reserveData)}
    >
      <div className={cardStyle.cardWrapper}>
        <div className={cardStyle.activeCardDetailsTitle}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          >
            <circle cx="16" cy="16" r="16" fill="white" />
            <path
              d="M8.81855 24.1855C8.31845 24.1855 7.89033 24.0074 7.5342 23.6513C7.17807 23.2951 7 22.867 7 22.3669V9.63709C7 9.13699 7.17807 8.70888 7.5342 8.35274C7.89033 7.99661 8.31845 7.81855 8.81855 7.81855H9.72782V6.90927C9.72782 6.65165 9.81496 6.43569 9.98923 6.26142C10.1635 6.08714 10.3795 6 10.6371 6C10.8947 6 11.1107 6.08714 11.2849 6.26142C11.4592 6.43569 11.5464 6.65165 11.5464 6.90927V7.81855H18.8205V6.90927C18.8205 6.65165 18.9077 6.43569 19.082 6.26142C19.2562 6.08714 19.4722 6 19.7298 6C19.9874 6 20.2034 6.08714 20.3777 6.26142C20.552 6.43569 20.6391 6.65165 20.6391 6.90927V7.81855H21.5484C22.0485 7.81855 22.4766 7.99661 22.8327 8.35274C23.1888 8.70888 23.3669 9.13699 23.3669 9.63709V14.1835C23.3669 14.4411 23.2798 14.657 23.1055 14.8313C22.9312 15.0056 22.7153 15.0927 22.4576 15.0927C22.2 15.0927 21.9841 15.0056 21.8098 14.8313C21.6355 14.657 21.5484 14.4411 21.5484 14.1835V13.2742H8.81855V22.3669H14.2742C14.5318 22.3669 14.7478 22.454 14.922 22.6283C15.0963 22.8026 15.1835 23.0186 15.1835 23.2762C15.1835 23.5338 15.0963 23.7498 14.922 23.924C14.7478 24.0983 14.5318 24.1855 14.2742 24.1855H8.81855ZM21.5484 26.004C20.5785 26.004 19.7109 25.735 18.9456 25.197C18.1803 24.659 17.6309 23.9581 17.2975 23.0943C17.2217 22.9276 17.2407 22.7647 17.3543 22.6056C17.468 22.4465 17.6158 22.3669 17.7976 22.3669C18.0098 22.3669 18.203 22.4313 18.3773 22.5601C18.5516 22.6889 18.6917 22.8519 18.7978 23.0489C19.0706 23.5338 19.4495 23.9202 19.9344 24.2082C20.4193 24.4961 20.9573 24.6401 21.5484 24.6401C22.4273 24.6401 23.1775 24.3294 23.7988 23.7081C24.4201 23.0868 24.7308 22.3366 24.7308 21.4576C24.7308 20.5787 24.4201 19.8285 23.7988 19.2072C23.1775 18.5858 22.4273 18.2752 21.5484 18.2752C21.1089 18.2752 20.6997 18.3547 20.3208 18.5139C19.942 18.673 19.6086 18.8965 19.3206 19.1845H19.9571C20.1541 19.1845 20.3171 19.2489 20.4459 19.3777C20.5747 19.5065 20.6391 19.6694 20.6391 19.8664C20.6391 20.0634 20.5747 20.2263 20.4459 20.3551C20.3171 20.484 20.1541 20.5484 19.9571 20.5484H17.9113C17.6536 20.5484 17.4377 20.4612 17.2634 20.2869C17.0891 20.1127 17.002 19.8967 17.002 19.6391V17.5932C17.002 17.3962 17.0664 17.2333 17.1952 17.1045C17.324 16.9757 17.4869 16.9113 17.684 16.9113C17.881 16.9113 18.0439 16.9757 18.1727 17.1045C18.3015 17.2333 18.3659 17.3962 18.3659 17.5932V18.207C18.7751 17.813 19.2524 17.4985 19.798 17.2636C20.3436 17.0287 20.927 16.9113 21.5484 16.9113C22.8062 16.9113 23.8784 17.3545 24.7649 18.2411C25.6515 19.1276 26.0947 20.1998 26.0947 21.4576C26.0947 22.7155 25.6515 23.7876 24.7649 24.6742C23.8784 25.5607 22.8062 26.004 21.5484 26.004Z"
              fill="#09081A"
            />
          </svg>

          <div className={cardStyle.cardHeader}>
            <strong>{reserveData.title}</strong>
            <div>{reserveData.sub_title}</div>
          </div>
        </div>
        <div className={cardStyle.activeCardDetailsMain}>
          {reserveData.details.map((elem, index) => {
            return (
              <div className={cardStyle.cardLayoutDU} key={index}>
                <div>{elem.key}</div>
                <section>{elem.value}</section>
              </div>
            );
          })}
        </div>
        <div className={cardStyle.activeCardDetailsMain}>
          <div className={cardStyle.packageWrapperDate}>
            {reserveData.booking_days.map((date, idx) => {
              date = date.date.split(" ");
              return (
                <div className={cardStyle.packageBoxDate} key={idx}>
                  <div className={cardStyle.dateBookBox}>
                    <div>{date[0]}</div>
                    <span>{`${date[1]} ${date[2]}`}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div
          className={cardStyle.pickupLocationDU}
          style={{ border: reserveData.drop_address ? "none" : "block" }}
        >
          <MdCircle size={10} style={{ color: "#009D61", paddingTop: "3px" }} />

          <div className={cardStyle.locationWrapperDU}>
            <div>{reserveData.bottom_heading}</div>
            <strong>{reserveData.bottom_text}</strong>
          </div>
        </div>

        <>
          {reserveData.drop_address && (
            <div className={cardStyle.pickupLocationDU}>
              <MdCircle size={10} style={{ color: "red", paddingTop: "3px" }} />

              <div className={cardStyle.locationWrapperDU}>
                <div style={{ color: "red" }}>Daily Drop Location</div>
                <strong>{reserveData.drop_address}</strong>
              </div>
            </div>
          )}
        </>
      </div>
    </div>
  );
};

export default ReserveCard;
